/**
 * config:{
 *   interval: 1, //间隔天数，间隔为整数
 *   runNow: false, //是否立即运行
 *   time: "14:00:00" //执行的时间点 时在0~23之间
 * }
 * @param {Object} config 定时任务配置项
 * @param {Function} func 需要定时的方法
 * @param {Object} params 定时方法的参数
 */
export function timingTask(config, func, params) {
  config.runNow && func(params)

  const nowTime = new Date().getTime()

  const timePoints = config.time.split(':').map(i => parseInt(i))

  let recent = new Date().setHours(...timePoints)

  recent >= nowTime || (recent += 24 * 3600000)

  return setTimeout(() => {
    func(params)

    setInterval(func(params), config.interval * 3600000)
  }, recent - nowTime)
}
